import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect, Route} from 'react-router-dom';


class AuthRoute extends Component {

    componentWillMount(){
      const { isLoggedIn, isAdmin, isManager } = this.props.authentication;
      const isAllowed = isLoggedIn && (isAdmin || isManager);
      if (!isAllowed) {
        //this.props.dispatch(logout());
      }
    }

    render() {
      const {component: Component, ...rest} = this.props;
      const {userState} = this.props.authentication;
      const isAllowed = userState === 'signed-in';

      return (
            <Route {...rest} render={props => (
              isAllowed ? (
                    <Component {...props}/>
                ) : (

                    <Redirect to={{
                        pathname: '/public/login',
                        state: { from: props.location }
                    }}/>
                )
            )}/>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        authentication: state.authentication
    };
};

export default connect(mapStateToProps)(AuthRoute);
